// extracted by mini-css-extract-plugin
export default {"thankyouPage":"style_thankyouPage__FlxU5","headerTitle":"style_headerTitle__O8ZDT"};